/**
 * API Configuration
 * Handles different environments (development vs production)
 */

// Determine the API base URL based on the environment
const getApiBaseUrl = (): string => {
    // In production, use relative URLs (proxied through nginx)
    // In development, use localhost:3001
    if (process.env.NODE_ENV === 'production') {
        return '/api';
    }
    return process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
};

// Determine the Socket.IO URL
const getSocketUrl = (): string => {
    if (process.env.NODE_ENV === 'production') {
        // In production, connect to the same host (nginx will proxy)
        return window.location.origin;
    }
    return process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';
};

export const API_BASE_URL = getApiBaseUrl();
export const SOCKET_URL = getSocketUrl();
